import React from 'react'
import { Link } from 'react-router-dom'
import { NAVIGATION } from '../../lib/navigation'

const formatTitle = (title) => {
    return title.length > 30 ? title.substring(0, 30) + '...' : title
}

const Breadcrumb = ({ crumbs }) => {
    return (
        <nav className="px-6 flex items-center h-12 relative bg-white" aria-label="Breadcrumb">
            <ol className="inline-flex items-start space-x-1 md:space-x-2 rtl:space-x-reverse flex-wrap">
                <li className="inline-flex items-center">
                    <Link to={NAVIGATION.INNER_NAVIGATION.DASHBOARD} className="inline-flex items-center uppercase text-sm text-gray-700 hover:text-primary">
                        <b>Dashboard</b>
                    </Link>
                </li>
                {crumbs && crumbs.map((crumb, idx) => <li key={idx}>
                    <div className="flex items-center">
                        <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                        </svg>
                        <Link to={"#"} className="ms-1 text-sm text-gray-400 uppercase hover:text-primary md:ms-2">{formatTitle(crumb.title)}</Link>
                    </div>
                </li>)}
            </ol>
        </nav>
    )
}

export default Breadcrumb